import { useState } from 'react';

export default function HomePage() {
  const [activeProduct, setActiveProduct] = useState(0);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState('');
  const [albumModalOpen, setAlbumModalOpen] = useState(false);
  const [currentAlbumIndex, setCurrentAlbumIndex] = useState(0);

  const products = [
    {
      title: "Madeira Bruta",
      description: "Tábuas, ripas, caibros e outros produtos de madeira de pinus e eucalipto reflorestados de alta qualidade, ideais para construção civil e marcenaria.",
      icon: "ri-tree-line",
      image: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/aa5291b4c72f13cf8cd5693010678382.jpeg",
      album: [
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/aa5291b4c72f13cf8cd5693010678382.jpeg",
          alt: "Tábuas de madeira bruta empilhadas organizadamente"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/09ae4dff87c94c304e77d2322b3252ad.jpeg",
          alt: "Madeira bruta de alta qualidade"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/f8c46c953855adb31d3b7a5cbfe715e6.jpeg",
          alt: "Estoque de madeira bruta empilhada"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/93d81763202e164ea1526915a86e5db7.jpeg",
          alt: "Madeira bruta em estoque organizado"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/ffa6e365a16d38f9481330563095dfdd.jpeg",
          alt: "Madeira bruta de qualidade superior"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/54723f71776653869f0490bb2ca5a1c2.jpeg",
          alt: "Estoque de madeira bruta em grande quantidade"
        }
      ]
    },
    {
      title: "Madeira Beneficiada",
      description: "Produtos com acabamento perfeito, aplainados e cortados sob medida para suas necessidades específicas.",
      icon: "ri-hammer-line",
      image: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/a73cbf7031ab8a182aef5347ce2e57bc.jpeg",
      album: [
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/a73cbf7031ab8a182aef5347ce2e57bc.jpeg",
          alt: "Madeira beneficiada com acabamento perfeito"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/19dcb6c9515c61b2b4f9ffab699cd730.jpeg",
          alt: "Madeira beneficiada aplainada de alta qualidade"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/13735010c9b3bec162027a2fe84225d6.jpeg",
          alt: "Madeira beneficiada com acabamento superior"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/3415c9e10ee41833b885abd6f86907e6.jpeg",
          alt: "Madeira beneficiada de qualidade premium"
        }
      ]
    },
    {
      title: "Madeira para Embalagens e Pallets",
      description: "Madeira específica para fabricação de embalagens, caixas e pallets industriais com resistência e durabilidade.",
      icon: "ri-box-3-line",
      image: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/0bc05c68ea85d5aab40369bf4e3261d1.jpeg",
      album: [
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/0bc05c68ea85d5aab40369bf4e3261d1.jpeg",
          alt: "Madeira para embalagens e pallets industriais"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/0b6cc16a328485e99687bf41e1018648.jpeg",
          alt: "Madeira para fabricação de embalagens e pallets"
        }
      ]
    },
    {
      title: "Cavaco",
      description: "Cavaco de madeira de alta qualidade para biomassa, aquecimento e processos industriais sustentáveis.",
      icon: "ri-fire-line",
      image: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/6cf53c0b10f1d5485c534ffcc68458fa.jpeg",
      album: [
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/6cf53c0b10f1d5485c534ffcc68458fa.jpeg",
          alt: "Cavaco de madeira de alta qualidade"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/25647e725389b8db6d7ff170e6726ea8.jpeg",
          alt: "Cavaco de madeira para biomassa e aquecimento"
        }
      ]
    },
    {
      title: "Serragem",
      description: "Serragem fina e grossa para diversos usos industriais, agricultura e compostagem orgânica.",
      icon: "ri-leaf-line",
      image: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/fd7dffe85497db755ead786d4f270b9a.jpeg"
    },
    {
      title: "Maravalha",
      description: "Produção própria de maravalha a granel para Compost Barn e Freestall, bem como maravalha esterilizada e enfardada para aviários.",
      icon: "ri-scissors-cut-line",
      image: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/c6f4085dee63e196cc1d641c800dcb79.jpeg",
      album: [
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/c6f4085dee63e196cc1d641c800dcb79.jpeg",
          alt: "Maravalha - aparas de madeira em formato de fitas"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/b1e504b28a8022484d5a7cc31b4d595b.jpeg",
          alt: "Maravalha de alta qualidade para embalagens"
        },
        {
          url: "https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/c3d80dfacfaf1cdf7fb5e4b747e728d2.jpeg",
          alt: "Maravalha para proteção de produtos"
        }
      ]
    }
  ];

  const services = [
    {
      title: "Madeira Beneficiada",
      description: "Produtos de alta qualidade com acabamento perfeito para suas necessidades específicas.",
      icon: "ri-hammer-line"
    },
    {
      title: "Cortes Especiais",
      description: "Cortes personalizados e precisos para projetos únicos e especializados.",
      icon: "ri-scissors-line"
    },
    {
      title: "Entrega Própria",
      description: "Frota própria garantindo segurança e pontualidade na entrega dos seus produtos.",
      icon: "ri-truck-line"
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const openImageModal = (imageUrl: string) => {
    setSelectedImageUrl(imageUrl);
    setImageModalOpen(true);
  };

  const closeImageModal = () => {
    setImageModalOpen(false);
    setSelectedImageUrl('');
  };

  const openAlbumModal = (productIndex: number) => {
    const product = products[productIndex];
    if (product.album && product.album.length > 0) {
      setCurrentAlbumIndex(0);
      setAlbumModalOpen(true);
      setActiveProduct(productIndex);
    }
  };

  const closeAlbumModal = () => {
    setAlbumModalOpen(false);
    setCurrentAlbumIndex(0);
  };

  const nextAlbumImage = () => {
    const product = products[activeProduct];
    if (product.album) {
      setCurrentAlbumIndex((prev) => (prev + 1) % product.album.length);
    }
  };

  const prevAlbumImage = () => {
    const product = products[activeProduct];
    if (product.album) {
      setCurrentAlbumIndex((prev) => (prev - 1 + product.album.length) % product.album.length);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/3790aec0da60bf98e63603e63c3b99a4.png" 
                alt="Madeireira Walter" 
                className="h-12 w-auto"
              />
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#inicio" className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer whitespace-nowrap">Início</a>
              <a href="#sobre" className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer whitespace-nowrap">Sobre Nós</a>
              <a href="#produtos" className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer whitespace-nowrap">Produtos</a>
              <a href="#contato" className="text-gray-700 hover:text-green-800 transition-colors cursor-pointer whitespace-nowrap">Contato</a>
            </nav>
            <div className="flex items-center space-x-4">
              <div className="text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <i className="ri-phone-line text-green-600"></i>
                  <span>(55) 3551-1363</span>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-whatsapp-line text-green-600"></i>
                  <span>(55) 99964-0805</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section id="inicio" className="relative h-screen flex items-center justify-center bg-cover bg-center" 
               style={{ backgroundImage: 'url(https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/ec22431e66fb1c6e73675e516bd4f861.jpeg)' }}>
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
          <h1 className="text-5xl md:text-7xl font-bold Mb-6 leading-tight">
            Tradição em Madeira
            <span className="block text-green-400">Há Mais de 50 Anos</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            Três gerações de experiência oferecendo produtos de qualidade superior com atendimento personalizado
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => scrollToSection('produtos')}
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Conheça Nossos Produtos
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Fale Conosco
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="sobre" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Uma História de Tradição e Qualidade
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                A Madeireira Walter é uma empresa familiar que está na sua terceira geração, 
                sempre buscando melhor atender a todos os clientes de uma forma humanizada e individual.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Contamos com produtos únicos de acordo com a necessidade final de utilização, 
                garantindo qualidade e satisfação em cada projeto.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-award-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">50+ Anos</h3>
                    <p className="text-gray-600">de experiência</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-team-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">3ª Geração</h3>
                    <p className="text-gray-600">empresa familiar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="produtos" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nossos Produtos
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Oferecemos uma linha completa de produtos em madeira com qualidade superior e tradição familiar
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-product-shop>
            {products.map((product, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:transform hover:-translate-y-2"
              >
                <div 
                  className="h-48 overflow-hidden cursor-pointer"
                  onClick={() => {
                    if (product.album && product.album.length > 0) {
                      openAlbumModal(index);
                    } else {
                      openImageModal(product.image);
                    }
                  }}
                >
                  <img 
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${product.icon} text-2xl text-green-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{product.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {product.description}
                  </p>
                  <div className="flex items-center justify-end">
                    <div className="flex space-x-2">
                      <a href="https://www.instagram.com/madeireirawalter" target="_blank" rel="noopener noreferrer" 
                         className="w-8 h-8 bg-gray-100 hover:bg-green-100 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                        <i className="ri-instagram-line text-gray-600 hover:text-green-600"></i>
                      </a>
                      <a href="https://www.facebook.com/share/19n4L8pRt2/" target="_blank" rel="noopener noreferrer"
                         className="w-8 h-8 bg-gray-100 hover:bg-green-100 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                        <i className="ri-facebook-line text-gray-600 hover:text-green-600"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div 
              className="cursor-zoom-in"
              onClick={() => openImageModal("https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/ec22431e66fb1c6e73675e516bd4f861.jpeg")}
            >
              <img 
                src="https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/ec22431e66fb1c6e73675e516bd4f861.jpeg"
                alt="Produtos de madeira de alta qualidade"
                className="rounded-lg shadow-lg object-cover w-full h-96 hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Qualidade Garantida em Cada Produto
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Mão de Obra Especializada</h4>
                    <p className="text-gray-600">Profissionais experientes garantem acabamento perfeito</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Frota Própria</h4>
                    <p className="text-gray-600">Entrega segura e pontual diretamente ao seu local</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Cortes Personalizados</h4>
                    <p className="text-gray-600">Produtos sob medida para cada necessidade específica</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contato" className="py-20 bg-green-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-4xl font-bold mb-6">
                Entre em Contato Conosco
              </h2>
              <p className="text-xl text-green-100 mb-8">
                Estamos prontos para atender suas necessidades com a qualidade e tradição que você merece.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-700 rounded-lg flex items-center justify-center">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold">Telefones</h3>
                    <div className="space-y-1">
                      <div className="flex items-center space-x-2">
                        <i className="ri-phone-line text-green-200"></i>
                        <p className="text-green-100">(55) 3551-1363</p>
                      </div>
                      <div className="flex items-center space-x-2">
                        <i className="ri-whatsapp-line"></i>
                        <p>(55) 99964-0805</p>
                      </div>
                      <p>Av. Itapiranga, 601 - Centro - Tenente Portela/RS</p>
                    </div>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-700 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold">Localização</h3>
                    <p className="text-green-100">Av. Itapiranga, 601 - Centro - Tenente Portela/RS</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-700 rounded-lg flex items-center justify-center">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold">Horário de Funcionamento</h3>
                    <p className="text-green-100">Segunda a Sexta: 7h às 18h</p>
                    <p className="text-green-100">Sábado: 7h às 12h</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-green-700 rounded-lg flex items-center justify-center">
                    <i className="ri-share-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold">Redes Sociais</h3>
                    <div className="flex space-x-3 mt-2">
                      <a href="https://www.instagram.com/madeireirawalter" target="_blank" rel="noopener noreferrer" 
                         className="w-8 h-8 bg-green-600 hover:bg-green-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                        <i className="ri-instagram-line text-white"></i>
                      </a>
                      <a href="https://www.facebook.com/share/19n4L8pRt2/" target="_blank" rel="noopener noreferrer"
                         className="w-8 h-8 bg-green-600 hover:bg-green-500 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                        <i className="ri-facebook-line text-white"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="flex space-x-4 mt-8">
                <a href="https://www.instagram.com/madeireirawalter" target="_blank" rel="noopener noreferrer" 
                   className="w-12 h-12 bg-green-700 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://www.facebook.com/share/19n4L8pRt2/" target="_blank" rel="noopener noreferrer"
                   className="w-12 h-12 bg-green-700 hover:bg-green-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-line text-xl"></i>
                </a>
              </div>
            </div>
            
            <div className="bg-white rounded-xl overflow-hidden shadow-lg">
              <div className="p-6 border-b border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Nossa Localização</h3>
                <p className="text-gray-600">Encontre-nos em Tenente Portela, RS</p>
              </div>
              <div className="h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3542.123456789!2d-53.7584!3d-27.3678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDIyJzA0LjEiUyA1M8KwNDUnMzAuMiJX!5e0!3m2!1spt-BR!2sbr!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localização da Madeireira Walter em Tenente Portela, RS"
                ></iframe>
              </div>
              <div className="p-6 bg-gray-50">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Endereço</h4>
                    <p className="text-gray-600">Av. Itapiranga, 601 - Centro - Tenente Portela/RS</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/8b5b20c0a43157531bb3d510dccda0be/3790aec0da60bf98e63603e63c3b99a4.png" 
                alt="Madeireira Walter" 
                className="h-16 w-auto mb-4"
              />
              <p className="text-gray-400 mb-4">
                Tradição familiar em madeira há mais de 50 anos, oferecendo qualidade e atendimento personalizado.
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Links Rápidos</h4>
              <ul className="space-y-2">
                <li><a href="#inicio" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Início</a></li>
                <li><a href="#sobre" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Sobre Nós</a></li>
                <li><a href="#produtos" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Produtos</a></li>
                <li><a href="#contato" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contato</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Contato</h4>
              <div className="space-y-2 text-gray-400">
                <div className="flex items-center space-x-2">
                  <i className="ri-phone-line"></i>
                  <p>(55) 3551-1363</p>
                </div>
                <div className="flex items-center space-x-2">
                  <i className="ri-whatsapp-line"></i>
                  <p>(55) 99964-0805</p>
                </div>
                <p>Av. Itapiranga, 601 - Centro - Tenente Portela/RS</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400">© 2025 Madeireira Walter Ltda. Todos os direitos reservados.</p>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer mt-4 md:mt-0">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* Album Modal */}
      {albumModalOpen && (
        <div 
          className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4"
          onClick={closeAlbumModal}
        >
          <button
            onClick={closeAlbumModal}
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line text-3xl text-white"></i>
          </button>
          
          <button
            onClick={(e) => {
              e.stopPropagation();
              prevAlbumImage();
            }}
            className="absolute left-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-left-s-line text-3xl text-white"></i>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              nextAlbumImage();
            }}
            className="absolute right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer z-10"
          >
            <i className="ri-arrow-right-s-line text-3xl text-white"></i>
          </button>

          <div 
            className="relative max-w-7xl max-h-[90vh] w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img 
              src={products[activeProduct].album?.[currentAlbumIndex]?.url || ''}
              alt={products[activeProduct].album?.[currentAlbumIndex]?.alt || ''}
              className="max-w-full max-h-full object-contain rounded-lg"
            />
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full text-sm">
              {currentAlbumIndex + 1} / {products[activeProduct].album?.length || 0}
            </div>
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-black/50 text-white px-6 py-3 rounded-full text-lg font-semibold">
              {products[activeProduct].title}
            </div>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {imageModalOpen && (
        <div 
          className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4"
          onClick={closeImageModal}
        >
          <button
            onClick={closeImageModal}
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer z-10"
          >
            <i className="ri-close-line text-3xl text-white"></i>
          </button>
          <div 
            className="relative max-w-7xl max-h-[90vh] w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img 
              src={selectedImageUrl}
              alt="Visualização em tela cheia"
              className="max-w-full max-h-full object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
}
